<script lang="ts">
    import type { PageData } from './$types';
    import { page } from '$app/stores';
    import { supportedLocales } from '$lib/i18n/initI18n.js';
    import { setContext } from 'svelte';
    import {
        LOCALE_CONTEXT_KEY,
        LOCALE_ISO_CONTEXT_KEY,
        PROPERTIES_CONTEXT_KEY,
        SHOP_CONTEXT_KEY
    } from '$lib/context.js';
    import ShopLayout from '$lib/layout/ShopLayout.svelte';
    import AgeCheck from '$lib/components/util/AgeCheck.svelte';
    import posthog from 'posthog-js';
    import { browser } from '$app/environment';

    export let data: PageData;

    // ugly workaround to get the language from the url
    const isoCodes = {
        de: 'de-DE',
        en: 'en-GB'
    };

    function sortOptionsByEnglishTranslation(data: any) {
        const sortedData = { ...data };

        for (const key in sortedData) {
            const property = sortedData[key];
            const options = property.options;

            // Convert options object to an array of entries and sort them
            const sortedEntries = Object.entries(options).sort(([, a], [, b]) => a['en-GB'].localeCompare(b['en-GB']));

            // Replace original options with sorted ones
            property.options = Object.fromEntries(sortedEntries);
        }

        return sortedData;
    }

    setContext(LOCALE_CONTEXT_KEY, data.language);
    setContext(LOCALE_ISO_CONTEXT_KEY, isoCodes[data.language]);

    setContext(SHOP_CONTEXT_KEY, data.shopContext);
    setContext(PROPERTIES_CONTEXT_KEY, sortOptionsByEnglishTranslation(data.shopProperties));

    $: if (browser) {
        const customer = data.shopContext.storeContext?.customer;
        if (customer) {
            posthog.identify(customer.id, {
                email: customer.email,
                name: `${customer.firstName} ${customer.lastName}`
            });

            let distinct_id = posthog.get_distinct_id();
            if (distinct_id) console.info(`User identified with id: ${posthog.get_distinct_id()}`);
            else console.warn(`User could not be identified.`);
        }
    }

    $: skipAgeCheckForPage =
        $page.url.pathname.includes('privacy') ||
        $page.url.pathname.includes('impressum') ||
        $page.url.pathname.includes('agb');
</script>

<svelte:head>
    {#each supportedLocales as locale (locale)}
        <link rel="alternate" hreflang={locale} href="{$page.url.origin}/{locale}{$page.url.pathname.slice(3)}" />
    {/each}
</svelte:head>

{#if data.ageCheckCookie === 'true' || skipAgeCheckForPage}
    <ShopLayout {data}>
        <slot />
    </ShopLayout>
{:else}
    <AgeCheck ageCookie={data.ageCheckCookie} />
{/if}
